import { render, staticRenderFns } from "./supplierInfo.vue?vue&type=template&id=006cab41&scoped=true"
import script from "./supplierInfo.vue?vue&type=script&lang=js"
export * from "./supplierInfo.vue?vue&type=script&lang=js"
import style0 from "./supplierInfo.vue?vue&type=style&index=0&id=006cab41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006cab41",
  null
  
)

export default component.exports